module.exports = __webpack_public_path__ + "static/media/background.5fc0c00e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/background.webp
// module id = 104
// module chunks = 0